<template>
  <router-link v-if="info.id" class="product-link myCard productCard" :to="adRoute(info, 'mallCar').url + info.id">
    <div v-if="!info.activityTag || info.activityTag">
      <!-- <div
      v-if="
        !info.activityTag ||
          (info.activityTag &&
            info.activityTag.activityTypeCode !== 'crowdFunding')
      "
    > -->
      <div class="sukText" v-if="info.activityItemInfoDto && info.activityItemInfoDto.activityInfoDto">
        <div
          v-if="
            info.activityItemInfoDto &&
              info.activityItemInfoDto.activityInfoDto &&
              info.activityItemInfoDto.activityInfoDto.activityType !== 3 &&
              info.activityItemInfoDto.activityInfoDto.activityStatus === 1 &&
              info.activityItemInfoDto.activityInfoDto.realStartTime < now &&
              info.activityItemInfoDto.activityInfoDto.realEndTime > now &&
              info.activityItemInfoDto.ifDisplay === true
          "
        >
          仅剩<span>{{ info.activityItemInfoDto.activityInfoDto.recordCount }}</span
          >{{ info.type == '0' ? '台' : '件' }}
        </div>
      </div>

      <div
        class="promotion"
        @click.prevent="showCode(info)"
        v-if="
          info.activityItemInfoDto &&
            info.activityItemInfoDto.activityInfoDto &&
            info.activityItemInfoDto.activityInfoDto.activityType !== 3
        "
      >
        <img :src="isShowQrcode ? shareRed : shareBlack" alt="" />
      </div>
      <div class="showQrcode" v-if="isShowQrcode">
        <div class="codeContent">
          <img src="../../../assets/images/mall/closeQrcode.png" @click.prevent="closeCode(info)" alt="" />
          <div :id="`qrcode${info.id}`" class="qrcodeBox"></div>
          <p>手机扫码分享</p>
        </div>
      </div>

      <div
        :class="type === true ? 'Deposit' : ''"
        v-if="
          (!adRoute(info).type && type) ||
            (info.activityItemInfoDto &&
              info.activityItemInfoDto.activityInfoDto &&
              info.activityItemInfoDto.activityInfoDto.activityType === 3)
        "
      >
        <span>订金</span>
      </div>
      <div :class="type === true ? 'Deposit' : ''" v-if="adRoute(info).type === 'fullSubtract' && type">
        <span>满减</span>
      </div>
      <div :class="type === true ? 'Deposit' : ''" v-if="adRoute(info).type === 'collocationPurchase' && type">
        <span>订金</span>
      </div>
      <!-- <div class="lotteryTag" v-if="adRoute(info).type === 'lotteryDraw' && type"></div> -->
      <!--抽奖-->
      <!-- <div :class="type === true ? 'Deposit' : ''" v-if="adRoute(info).type === 'secondKill'">
        <span>秒杀</span>
      </div> -->
      <!-- 限时抢购 -->
      <div
        :class="
          type === true
            ? info.activityTag && info.activityTag.activityName === '推荐购车'
              ? 'tagFestival Deposit'
              : info.activityItemInfoDto.activityInfoDto.activityType === 5
              ? 'DepositAc Deposit'
              : 'oneprice Deposit'
            : ''
        "
        v-if="adRoute(info).type === 'flashSale'"
      ></div>
      <div :class="type === true ? 'buyGifts' : ''" v-if="adRoute(info).type === 'buyGifts'">
        <!-- 买赠 -->
      </div>

      <!--<div class="productImage" :style="'background-image:url(' + info.mainImage + ')'"></div>-->
      <el-image class="productImage" :src="info.mainImage" fit="contain"></el-image>
      <div class="productDetail">
        <p class="productName" v-text="info.name"></p>
        <div
          class="productDiscount"
          v-if="
            info.activityItemInfoDto &&
              info.activityItemInfoDto.activityInfoDto &&
              info.activityItemInfoDto.activityInfoDto.activityType !== 3 &&
              info.activityItemInfoDto.activityInfoDto.activityDesc
          "
          v-html="change(info.activityItemInfoDto.activityInfoDto.activityDesc)"
        ></div>
        <div class="productDiscount" v-else v-html="change(info.advertise)"></div>
        <div class="proDeBot" v-if="adRoute(info).type === 'flashSale'">
          <p :class="type === true ? 'productPrice' : 'typePrice'">
            {{
              info.activityItemInfoDto &&
              info.activityItemInfoDto.activityItemDtoList &&
              info.activityItemInfoDto.activityItemDtoList[0].itemExtDto
                ? info.activityItemInfoDto.activityItemDtoList[0].itemExtDto.activityPrice
                : info.price | currency('￥', 2)
            }}
          </p>
          <el-button v-if="type && info.activityItemInfoDto && info.activityItemInfoDto.activityInfoDto" type="danger"
            >立即抢购</el-button
          >
        </div>
        <div class="proDe" v-else>
          <p :class="type === true ? 'productPrice' : 'typePrice'">
            {{
              info.activityItemInfoDto &&
              info.activityItemInfoDto.activityItemDtoList &&
              info.activityItemInfoDto.activityItemDtoList[0].itemExtDto
                ? info.activityItemInfoDto.activityItemDtoList[0].itemExtDto.activityPrice
                : info.price | currency('￥', 2)
            }}
          </p>
          <!-- <el-button v-if="type && info.activityItemInfoDto && info.activityItemInfoDto.activityInfoDto" type="danger"
            >立即预订</el-button
          > -->
        </div>
      </div>
    </div>
  </router-link>
  <div class="productCardJust" v-else>
    <div class="onlyProductImage" :style="'background-image:url(' + info.mainImage + ')'"></div>
  </div>
</template>
<style></style>
<script>
// import { Button } from 'element-ui'
import { ActivityRoute, getStorage } from '@/lib/utils'
import shareBlack from '../../../assets/images/mall/shareBlack.png'
import shareRed from '../../../assets/images/mall/shareRed.png'
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      now: 0,
      shareBlack,
      shareRed,
      isShowQrcode: false,
      agentId: ''
    }
  },
  props: ['info', 'type', 'beforeOpen'],
  components: {
    // ElButton: Button
  },
  watch: {},
  computed: {},
  /* eslint-disable */
  methods: {
    showCode(info) {
      this.isShowQrcode = true
      setTimeout(() => {
        const dealercardwebUrl = getStorage('domain', 'localStorage').h5mallUrl
        let code = new QRCode(document.getElementById(`qrcode${info.id}`), {
          width: 170,
          height: 170,
          padding: 10,
          colorDark: '#333',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
          text: `${dealercardwebUrl}${
            this.adRoute(info).url.match('/details/allCars')
              ? '/pages/index/product?id='
              : '/pages/index/productAccessories?id='
          }${info.id}${this.agentId ? '&agentId=' + this.agentId + '&agentRole=10' : ''}`
        })
      }, 20)
    },
    closeCode(info) {
      this.isShowQrcode = false
      document.getElementById(`qrcode${info.id}`) && (document.getElementById(`qrcode${info.id}`).innerHTML = '')
    },
    adRoute(attr, productType) {
      return ActivityRoute(attr, productType)
    },
    change: function(content) {
      if (content) {
        content = content.replace(/\s/g, '</br>')
        return content
      }
    }
  },
  created() {
    const isLogin = !!getStorage('accessToken')
    if (isLogin) {
      order.getUserDetailMsg().then((res) => {
        if (res.status === 200) {
          const { account } = res.data
          this.agentId = account.id
        }
      })
    }
  },
  mounted() {
    this.now = new Date().getTime()
  }
}
</script>
<style lang="scss" scoped>
.product-link {
  text-decoration: none;
  // display: inline-block;
}
/* .product-link:hover{
    box-shadow: 0px 0px 10px #ccc;
  } */
.productCardJust {
  width: 260px;
  height: 315px;
  position: relative;
  float: left;
  margin-bottom: 14px;
  transition: all 0.4s linear;
  background: rgba(255, 255, 255, 1);
}
.productCardJust:hover {
  /* cursor: pointer; */
  top: -3px;
  box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
}
.productCard {
  width: 260px;
  height: 315px;
  position: relative;
  float: left;
  margin-bottom: 14px;
  transition: all 0.4s linear;
  background: rgba(255, 255, 255, 1);
  .showQrcode {
    width: 260px;
    height: 315px;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 19;
    .codeContent {
      margin: 0 auto;
      padding: 10px;
      img:first-child {
        width: 20px;
        height: 20px;
        margin: 0 0 12px 8px;
      }
      .qrcodeBox {
        width: 170px;
        height: 170px;
        margin: 0 auto;
        padding: 10px;
        background: #fff;
      }
      p {
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #fff;
        text-align: center;
        margin: 12px 30px;
        line-height: 25px;
      }
    }
  }
  .sukText {
		z-index: 2;
    position: absolute;
    left: 25px;
    top: 0;
    height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    line-height: 22px;
    margin: 10px 0 0 20px;
    span {
      color: #c6001f;
    }
  }
  .promotion {
		z-index: 2;
    position: absolute;
    top: 0;
    margin: 12px 0 0 20px;
    img {
      width: 17px;
      height: 17px;
    }
    // span {
    //   font-size:14px;
    //   font-family:NotoSansHans-Regular;
    //   font-weight:400;
    //   color:#1E1E1E;
    //   position: relative;
    //   top: -4px;
    // }
  }
}

.productCard:hover {
  /* cursor: pointer; */
  top: -3px;
  box-shadow: 0px 4px 10px 0px rgba(27, 50, 71, 0.22);
}
.Deposit {
  width: 60px;
  height: 66px;
  position: absolute;
  top: 0px;
  right: 0px;
	z-index: 2;
  background-image: url('../../../assets/flag.png');
  background-repeat: no-repeat;
  > span {
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    display: inline-block;
    transform: translateX(25px) translateY(15px) rotate(45deg);
  }
}
.lotteryTag {
  height: 59px;
  width: 60px;
  background-size: 100% 100%;
  background: url('../../../assets/images/activity/lottery/lotteryTab.png') no-repeat;
  position: absolute;
  top: 0px;
  right: 0px;
}
.tagFestival {
  height: 66px;
  width: 60px;
  background-size: 60px 66px;
  background-image: url('../../../assets/images/mall/recommendBuy.png');
}
.DepositAc {
  height: 66px;
  width: 60px;
  background-size: 60px 66px;
  background-image: url('../../../assets/images/mall/flashSale.png');
}
.oneprice {
  height: 66px;
  width: 60px;
  background-size: 60px 66px;
  background-image: url('../../../assets/images/mall/oneprice.png');
}
.buyGifts {
  position: absolute;
  top: 0px;
  right: 0px;
  height: 59px;
  width: 60px;
  background-size: 60px 59px;
  background-image: url('../../../assets/images/mall/buyGifts.png');
}
.productImage {
  width: 259px;
  height: 150px;
  overflow: hidden;
  margin-right: 1px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}
.onlyProductImage {
  width: 260px;
  height: 315px;
  overflow: hidden;
  margin-right: 1px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}
.productDetail {
  .productName {
    padding: 0px 20px;
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .productDiscount {
    // height: 60px;
    box-sizing: border-box;
    padding-top: 5px;
    margin-top: 8px;
    // margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #666666;
    padding: 0px 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // display: block;
    // display:-webkit-box;
    // /* autoprefixer: off */
    // -webkit-box-orient: vertical; // 参考
    // /* autoprefixer: on */
    // -webkit-line-clamp:2;
  }
  .typePrice {
    margin: 30px 0;
    padding: 0px 20px;
    font-size: 16px;
    font-weight: 500;
    color: #c6001f;
  }
  .productPrice {
    margin: 7px 0;
    padding: 0px 20px;
    font-size: 24px;
    font-weight: 500;
    color: #c6001f;
  }
  ::v-deep {
    .el-button--danger {
      background-color: #c6001f;
      border-color: #c6001f;
    }
    .el-button {
      width: 220px;
      height: 40px;
      border-radius: 0;
      margin-left: 20px;
    }
  }
}
</style>
